export default {
  donor: [
    {
      order: 1,
      label: 'Donor ID',
      dataKey: 'donor.id',
      width: 82
    },
    {
      order: 1,
      label: 'Donor Name',
      dataKey: 'donor.name',
      width: 200
    }
  ],
  inventoryLocation: [
    {
      order: 2,
      label: 'Location ID',
      dataKey: 'inventoryLocation.id',
      width: 96
    },
    {
      order: 2,
      label: 'Location Name',
      dataKey: 'inventoryLocation.name',
      width: 200
    }
  ],
  item: [
    {
      order: 3,
      label: 'Item ID',
      dataKey: 'item.id',
      width: 80
    },
    {
      order: 3,
      label: 'Item Name',
      dataKey: 'item.name',
      width: 200
    }
  ],
  quantity: {
    order: 4,
    label: 'Quantity',
    dataKey: 'quantity',
    width: 100
  },
  weight: {
    order: 5,
    label: 'Weight',
    dataKey: 'weight',
    width: 100
  },
  points: {
    order: 6,
    label: 'Points',
    dataKey: 'points',
    width: 100
  },
  price: {
    order: 7,
    label: 'Price',
    dataKey: 'price',
    width: 100
  }
};
